import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';

export default function RedirectProjectList() {
  const navigate = useNavigate();
    
      useEffect(() => {
        navigate('/projectlist'); 
      }, [navigate]); 
    
      return null; 
}
